import { createTheme, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import React from 'react';
import '../../@css/mantine.css';
import Alert from './MantineAlert';
import Button from './MantineButton';
import Checkbox from './MantineCheckbox';
import Colors from './MantineColors';
import Combobox from './MantineCombobox';
import HoverCard from './MantineHoverCard';
import Inputs from './MantineInputs';
import Pill from './MantinePill';
import Popover from './MantinePopover';
import Switch from './MantineSwitch';
import Tabs from './MantineTabs';
import Tooltip from './MantineTooltip';

const theme = createTheme({
    fontFamily: 'Rubik',
    primaryColor: 'primary',
    components: {
        Alert,
        Button,
        Checkbox,
        Combobox,
        HoverCard,
        ...Inputs,
        Pill,
        Popover,
        Switch,
        Tabs,
        Tooltip,
    },
    colors: Colors as any
});

export const MantineConfig = ({ children }: { children: React.ReactNode }) => {
    return <MantineProvider
        defaultColorScheme="light"
        withCssVariables
        theme={theme}
    >
        {children}
    </MantineProvider>;
};
